(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const wrapper = document.querySelector('.sm-header-wrapper');
    if (!wrapper) return;

    const SCROLL_DELTA = 4;
    let lastY = window.scrollY;
    let lastState = 'anchored';
    let ticking = false;

    /* Anchored top: samokalibracja - mierzymy gdzie navbar wyladowal
       wzgledem poczatku pierwszej sekcji i korygujemy roznice */
    function syncAnchorTop() {
      if (wrapper.hasAttribute('data-pos')) return; /* tylko stan zakotwiczony */
      const target = wrapper.nextElementSibling;
      if (!target) return;
      wrapper.style.removeProperty('--sm-anchor-top');
      const wTop = wrapper.getBoundingClientRect().top;
      const tTop = target.getBoundingClientRect().top;
      const delta = Math.round(tTop - wTop);
      if (delta !== 0) wrapper.style.setProperty('--sm-anchor-top', 'calc(14px + ' + delta + 'px)');
    }
    syncAnchorTop();
    window.addEventListener('resize', syncAnchorTop, { passive: true });
    window.addEventListener('load', syncAnchorTop, { once: true });

    function setState(next) {
      if (next === lastState) return;
      lastState = next;
      if (next === 'anchored') {
        wrapper.removeAttribute('data-pos');
        wrapper.removeAttribute('data-vis');
      } else if (next === 'hidden') {
        wrapper.setAttribute('data-pos', 'fixed');
        wrapper.setAttribute('data-vis', 'hidden');
      } else if (next === 'revealed') {
        wrapper.setAttribute('data-pos', 'fixed');
        wrapper.setAttribute('data-vis', 'revealed');
      }
    }

    function update() {
      ticking = false;
      const y = Math.max(0, window.scrollY);
      const threshold = window.innerHeight * 0.02;

      if (y < threshold) {
        setState('anchored');
      } else if (y > lastY + SCROLL_DELTA) {
        setState('hidden');
      } else if (y < lastY - SCROLL_DELTA) {
        setState('revealed');
      }
      lastY = y;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });

    update();
  })();

  /* Mega menu - hover */
  (function () {
    const header = document.querySelector('[data-sm-header]');
    const wrapper = document.querySelector('.sm-header-wrapper');
    const trigger = document.querySelector('[data-sm-megamenu-trigger]');
    const megamenu = document.querySelector('[data-sm-megamenu]');
    const megaOverlay = document.querySelector('[data-sm-megamenu-overlay]');
    if (!header || !trigger || !megamenu) return;

    /* Move overlay to body to escape transformed wrapper (fixed positioning fix) */
    if (megaOverlay && megaOverlay.parentElement !== document.body) {
      document.body.appendChild(megaOverlay);
    }

    let closeTimer = null;

    function open() {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      header.setAttribute('data-megamenu-open', 'true');
      if (wrapper) wrapper.setAttribute('data-megamenu-open', 'true');
      if (megaOverlay) megaOverlay.setAttribute('data-open', 'true');
    }
    function scheduleClose() {
      if (closeTimer) clearTimeout(closeTimer);
      closeTimer = setTimeout(() => {
        header.removeAttribute('data-megamenu-open');
        if (wrapper) wrapper.removeAttribute('data-megamenu-open');
        if (megaOverlay) megaOverlay.setAttribute('data-open', 'false');
      }, 120);
    }

    trigger.addEventListener('mouseenter', open);
    trigger.addEventListener('mouseleave', scheduleClose);
    megamenu.addEventListener('mouseenter', open);
    megamenu.addEventListener('mouseleave', scheduleClose);

    /* Tabs */
    const tabs = megamenu.querySelectorAll('[data-tab-index]');
    const panels = megamenu.querySelectorAll('[data-panel-index]');
    let activeIndex = 0;

    function setActiveTab(newIdx) {
      if (newIdx === activeIndex) return;
      const goingForward = newIdx > activeIndex;
      tabs.forEach(t => {
        const tIdx = parseInt(t.getAttribute('data-tab-index'), 10);
        t.classList.toggle('is-active', tIdx === newIdx);
        t.setAttribute('aria-selected', tIdx === newIdx ? 'true' : 'false');
      });
      panels.forEach(p => {
        const pIdx = parseInt(p.getAttribute('data-panel-index'), 10);
        const wasActive = p.classList.contains('is-active');
        const willBeActive = pIdx === newIdx;

        if (willBeActive && !wasActive) {
          p.classList.remove('is-leaving');
          /* Position incoming panel off-screen on the side it's coming FROM (no transition) */
          p.style.transition = 'none';
          p.style.transform = goingForward ? 'translateX(100%)' : 'translateX(-100%)';
          /* Force reflow so the next change animates */
          void p.offsetWidth;
          p.style.transition = '';
          /* Now slide to center */
          p.style.transform = '';
          p.classList.add('is-active');
          p.setAttribute('aria-hidden', 'false');
        } else if (wasActive && !willBeActive) {
          /* Exiting panel slides off-screen in opposite direction */
          p.classList.remove('is-active');
          p.classList.add('is-leaving');
          p.style.transform = goingForward ? 'translateX(-100%)' : 'translateX(100%)';
          p.setAttribute('aria-hidden', 'true');
          setTimeout(() => {
            p.classList.remove('is-leaving');
            p.style.transform = '';
          }, 540);
        }
      });
      activeIndex = newIdx;
    }

    tabs.forEach(tab => {
      tab.addEventListener('mouseenter', () => {
        const idx = parseInt(tab.getAttribute('data-tab-index'), 10);
        setActiveTab(idx);
      });
    });
  })();

  /* Mobile drawer */
  (function () {
    const hamburger = document.querySelector('[data-sm-mobile-toggle]');
    const drawer = document.querySelector('[data-sm-drawer]');
    if (!hamburger || !drawer) return;

    /* Move drawer to body to escape transformed ancestor (header-wrapper has will-change/transform) */
    if (drawer.parentElement !== document.body) {
      document.body.appendChild(drawer);
    }
    const drawerOverlay = document.querySelector('[data-sm-drawer-overlay]');
    if (drawerOverlay && drawerOverlay.parentElement !== document.body) {
      document.body.appendChild(drawerOverlay);
    }

    const wrapperEl = document.querySelector('.sm-header-wrapper');
    const headerEl = document.querySelector('[data-sm-header]');

    function setOpen(open) {
      drawer.setAttribute('data-open', open ? 'true' : 'false');
      drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      if (drawerOverlay) drawerOverlay.setAttribute('data-open', open ? 'true' : 'false');
      hamburger.setAttribute('aria-expanded', open ? 'true' : 'false');
      hamburger.setAttribute('aria-label', open ? 'Zamknij menu' : 'Otwórz menu');
      document.body.style.overflow = open ? 'hidden' : '';
      if (wrapperEl) {
        if (open) wrapperEl.setAttribute('data-drawer-open', 'true');
        else wrapperEl.removeAttribute('data-drawer-open');
      }
      if (headerEl) {
        if (open) headerEl.setAttribute('data-drawer-open', 'true');
        else headerEl.removeAttribute('data-drawer-open');
      }
    }

    hamburger.addEventListener('click', (e) => {
      e.preventDefault();
      const isOpen = drawer.getAttribute('data-open') === 'true';
      setOpen(!isOpen);
    });

    if (drawerOverlay) drawerOverlay.addEventListener('click', () => setOpen(false));

    /* Close on Escape */
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.getAttribute('data-open') === 'true') {
        setOpen(false);
      }
    });

    /* Tabs - sliding track carousel */
    const tabs = drawer.querySelectorAll('[data-drawer-tab-index]');
    const panels = drawer.querySelectorAll('[data-drawer-panel-index]');
    const track = drawer.querySelector('[data-sm-drawer-track]');

    function setActiveDrawerTab(newIdx) {
      tabs.forEach(t => {
        const tIdx = parseInt(t.getAttribute('data-drawer-tab-index'), 10);
        t.classList.toggle('is-active', tIdx === newIdx);
        t.setAttribute('aria-selected', tIdx === newIdx ? 'true' : 'false');
      });
      panels.forEach(p => {
        const pIdx = parseInt(p.getAttribute('data-drawer-panel-index'), 10);
        p.classList.toggle('is-active', pIdx === newIdx);
        p.setAttribute('aria-hidden', pIdx === newIdx ? 'false' : 'true');
      });
      if (track) {
        track.style.transform = 'translateX(-' + (newIdx * 100) + '%)';
      }
    }

    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const idx = parseInt(tab.getAttribute('data-drawer-tab-index'), 10);
        setActiveDrawerTab(idx);
        tab.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      });
    });

    /* Close drawer on viewport resize to desktop */
    let resizeTimer;
    window.addEventListener('resize', () => {
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        if (window.innerWidth >= 990 && drawer.getAttribute('data-open') === 'true') {
          setOpen(false);
        }
      }, 120);
    });
  })();

  /* Cart drawer */
  (function () {
    const triggers = document.querySelectorAll('[data-sm-cart-trigger]');
    const cartDrawer = document.querySelector('[data-sm-cart-drawer]');
    const cartOverlay = document.querySelector('[data-sm-cart-overlay]');
    const cartClose = document.querySelector('[data-sm-cart-close]');
    if (!cartDrawer) return;

    /* Move cart drawer + overlay to body to escape any transformed ancestor */
    if (cartDrawer.parentElement !== document.body) {
      document.body.appendChild(cartDrawer);
    }
    if (cartOverlay && cartOverlay.parentElement !== document.body) {
      document.body.appendChild(cartOverlay);
    }

    function setCartOpen(open) {
      cartDrawer.setAttribute('data-open', open ? 'true' : 'false');
      cartDrawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      if (cartOverlay) cartOverlay.setAttribute('data-open', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
    }

    triggers.forEach(t => {
      t.addEventListener('click', (e) => {
        e.preventDefault();
        setCartOpen(true);
      });
    });
    /* Delegated close handler - works after innerHTML replace */
    cartDrawer.addEventListener('click', function(e) {
      if (e.target.closest('[data-sm-cart-close]')) {
        e.preventDefault();
        setCartOpen(false);
      }
    });
    if (cartOverlay) cartOverlay.addEventListener('click', () => setCartOpen(false));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && cartDrawer.getAttribute('data-open') === 'true') {
        setCartOpen(false);
      }
    });

    /* Expose global cart API for PDP / other sections */
    window.smCart = window.smCart || {};
    window.smCart.open = function() { setCartOpen(true); };
    window.smCart.close = function() { setCartOpen(false); };
    window.smCart.refresh = function(html) { refreshCartDrawerFromHtml(html); };

    /* Refresh cart drawer + cart triggers without page reload */
    function refreshCartDrawerFromHtml(html) {
      if (!html) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newDrawer = doc.querySelector('[data-sm-cart-drawer]');
      if (newDrawer) cartDrawer.innerHTML = newDrawer.innerHTML;
      const newTriggers = doc.querySelectorAll('[data-sm-cart-trigger]');
      const currentTriggers = document.querySelectorAll('[data-sm-cart-trigger]');
      newTriggers.forEach(function(nt, i) {
        const ct = currentTriggers[i];
        if (!ct) return;
        if (nt.querySelector('svg') === null) ct.innerHTML = nt.innerHTML;
        if (nt.hasAttribute('aria-label')) ct.setAttribute('aria-label', nt.getAttribute('aria-label'));
      });
    }

    /* Recommend product "DODAJ" form - add to cart via API + refresh drawer */
    cartDrawer.addEventListener('submit', function(e) {
      const form = e.target.closest('.sm-cart-drawer__recommend-form');
      if (!form) return;
      e.preventDefault();
      const idInput = form.querySelector('input[name="id"]');
      if (!idInput || !idInput.value) return;
      const variantId = idInput.value;
      const submitBtn = form.querySelector('button[type="submit"]');
      if (submitBtn) submitBtn.disabled = true;
      cartDrawer.classList.add('is-updating');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }], sections: 'header' })
      })
        .then(function(res) { return res.ok ? res.json() : null; })
        .then(function(data) {
          if (data && data.sections && data.sections.header) {
            refreshCartDrawerFromHtml(data.sections.header);
          } else {
            window.location.reload();
            return;
          }
          cartDrawer.classList.remove('is-updating');
          /* Flash animation */
          const flashEls = cartDrawer.querySelectorAll('.sm-cart-drawer__item-price, .sm-cart-drawer__subtotal-amount, .sm-cart-drawer__shipping-text, .sm-cart-drawer__title, .sm-cart-drawer__shipping-fill, .sm-cart-drawer__item-qty');
          flashEls.forEach(function(el) {
            el.classList.remove('is-flash');
            void el.offsetWidth;
            el.classList.add('is-flash');
            setTimeout(function() { el.classList.remove('is-flash'); }, 600);
          });
        })
        .catch(function() { window.location.reload(); });
    });

    cartDrawer.addEventListener('click', function(e) {
      const btn = e.target.closest('.sm-cart-drawer__qty-btn');
      if (!btn) return;
      e.preventDefault();
      const qtyBox = btn.closest('.sm-cart-drawer__item-qty');
      const itemEl = btn.closest('.sm-cart-drawer__item');
      if (!qtyBox || !itemEl) return;
      const lineKey = qtyBox.getAttribute('data-line-key');
      const action = btn.getAttribute('data-action');
      const currentQty = parseInt(itemEl.getAttribute('data-line-qty') || '1', 10);
      const newQty = action === 'increase' ? currentQty + 1 : Math.max(0, currentQty - 1);
      btn.disabled = true;
      cartDrawer.classList.add('is-updating');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity: newQty, sections: 'header' })
      })
        .then(function(res) { return res.ok ? res.json() : null; })
        .then(function(data) {
          if (data && data.sections && data.sections.header) {
            refreshCartDrawerFromHtml(data.sections.header);
            cartDrawer.classList.remove('is-updating');
            /* Flash animation on updated prices/totals */
            const flashEls = cartDrawer.querySelectorAll('.sm-cart-drawer__item-price, .sm-cart-drawer__subtotal-amount, .sm-cart-drawer__shipping-text, .sm-cart-drawer__title, .sm-cart-drawer__shipping-fill, .sm-cart-drawer__item-qty');
            flashEls.forEach(function(el) {
              el.classList.remove('is-flash');
              /* Force reflow to restart animation */
              void el.offsetWidth;
              el.classList.add('is-flash');
              setTimeout(function() { el.classList.remove('is-flash'); }, 600);
            });
          } else {
            window.location.reload();
          }
        })
        .catch(function() { window.location.reload(); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-bestsellers"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('[data-sm-carousel]').forEach(carousel => {
      if (carousel.__sm_carousel_inited) return;
      carousel.__sm_carousel_inited = true;
      const track = carousel.querySelector('[data-sm-carousel-track]');
      const prev = carousel.querySelector('[data-sm-carousel-prev]');
      const next = carousel.querySelector('[data-sm-carousel-next]');
      if (!track || !prev || !next) return;
      const scrollAmount = () => {
        const item = track.querySelector('li');
        if (!item) return 320;
        const style = window.getComputedStyle(track);
        const gap = parseFloat(style.gap) || 0;
        return item.offsetWidth + gap;
      };
      prev.addEventListener('click', () => track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' }));
      next.addEventListener('click', () => track.scrollBy({ left: scrollAmount(), behavior: 'smooth' }));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-collection-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      const root = document.querySelector('[data-sm-grid]');
      if (!root) return;
      const items = Array.from(root.children);
      const sortSelect = document.querySelector('[data-sm-sort]');

      function readSortFromUrl() {
        const url = new URL(window.location.href);
        return url.searchParams.get('sort_by') || 'manual';
      }
      function writeSortToUrl(sort) {
        const url = new URL(window.location.href);
        if (sort && sort !== 'manual') url.searchParams.set('sort_by', sort);
        else url.searchParams.delete('sort_by');
        window.history.replaceState(null, '', url.toString());
      }

      function applySort(sortBy) {
        const sorted = items.slice().sort((a, b) => {
          const ap = parseFloat(a.getAttribute('data-price') || '0');
          const bp = parseFloat(b.getAttribute('data-price') || '0');
          const at = (a.getAttribute('data-title') || '');
          const bt = (b.getAttribute('data-title') || '');
          const ac = parseInt(a.getAttribute('data-created') || '0', 10);
          const bc = parseInt(b.getAttribute('data-created') || '0', 10);
          const ai = parseInt(a.getAttribute('data-original-index') || '0', 10);
          const bi = parseInt(b.getAttribute('data-original-index') || '0', 10);
          switch (sortBy) {
            case 'price-ascending': return ap - bp;
            case 'price-descending': return bp - ap;
            case 'title-ascending': return at.localeCompare(bt);
            case 'title-descending': return bt.localeCompare(at);
            case 'created-ascending': return ac - bc;
            case 'created-descending': return bc - ac;
            default: return ai - bi;
          }
        });
        sorted.forEach(item => root.appendChild(item));
      }

      if (sortSelect) {
        const initialSort = readSortFromUrl();
        sortSelect.value = initialSort;
        if (initialSort !== 'manual') applySort(initialSort);
        sortSelect.addEventListener('change', () => {
          const sortBy = sortSelect.value;
          applySort(sortBy);
          writeSortToUrl(sortBy);
        });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-footer"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('[data-sm-locale-submit]').forEach(function(select) {
      select.addEventListener('change', function() {
        if (this.form) this.form.submit();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-gift-sets"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('[data-sm-carousel]').forEach(carousel => {
      if (carousel.__sm_carousel_inited) return;
      carousel.__sm_carousel_inited = true;
      const track = carousel.querySelector('[data-sm-carousel-track]');
      const prev = carousel.querySelector('[data-sm-carousel-prev]');
      const next = carousel.querySelector('[data-sm-carousel-next]');
      if (!track || !prev || !next) return;
      const scrollAmount = () => {
        const item = track.querySelector('li');
        if (!item) return 320;
        const style = window.getComputedStyle(track);
        const gap = parseFloat(style.gap) || 0;
        return item.offsetWidth + gap;
      };
      prev.addEventListener('click', () => track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' }));
      next.addEventListener('click', () => track.scrollBy({ left: scrollAmount(), behavior: 'smooth' }));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-pdp-giftset"]) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-sm-product-form]');
    if (!root) return;
    const section = root.closest('.sm-pdp');
    if (!section) return;

    /* ===== Gallery ===== */
    const mainImg = section.querySelector('[data-sm-main-image]');
    const thumbs = section.querySelectorAll('[data-sm-thumb]');
    const mainVideo = section.querySelector('[data-sm-main-video]');
    /* Preload duzych wersji w tle - pierwszy klik bez czekania na pobranie */
    function preloadThumbs() {
      thumbs.forEach(function(t) {
        const s = t.getAttribute('data-image-src');
        if (s) { const im = new Image(); im.src = s; }
      });
    }
    if (document.readyState === 'complete') preloadThumbs();
    else window.addEventListener('load', preloadThumbs, { once: true });

    const mainWrap = mainVideo ? mainVideo.closest('.sm-pdp__main') : null;
    function hideVideo() {
      if (mainWrap && mainWrap.classList.contains('is-video')) {
        mainVideo.pause();
        mainVideo.removeAttribute('src');
        mainVideo.load();
        mainWrap.classList.remove('is-video');
      }
    }

    let switchToken = 0;
    thumbs.forEach(function(th) {
      th.addEventListener('click', function() {
        const src = th.getAttribute('data-image-src');
        const alt = th.getAttribute('data-image-alt') || '';
        const vsrc = th.getAttribute('data-video-src');
        thumbs.forEach(function(t) { t.classList.remove('is-active'); });
        th.classList.add('is-active');

        /* Thumb wideo: pokaz odtwarzacz */
        if (vsrc && mainVideo && mainWrap) {
          switchToken++;
          if (src) mainVideo.poster = src;
          mainVideo.src = vsrc;
          mainWrap.classList.add('is-video');
          mainVideo.play().catch(function() {});
          return;
        }

        /* Thumb zdjecia: schowaj wideo, podmien obraz po zaladowaniu */
        hideVideo();
        if (!mainImg || !src) return;
        if (mainImg.getAttribute('src') === src) return; /* juz aktywne */
        const token = ++switchToken;
        const pre = new Image();
        pre.onload = function() {
          if (token !== switchToken) return; /* user kliknal juz inny thumb */
          mainImg.style.opacity = '0';
          setTimeout(function() {
            if (token !== switchToken) return;
            mainImg.src = src;
            mainImg.alt = alt;
            mainImg.style.opacity = '1';
          }, 150);
        };
        pre.onerror = function() {
          if (token !== switchToken) return;
          mainImg.src = src;
          mainImg.alt = alt;
          mainImg.style.opacity = '1';
        };
        pre.src = src;
      });
    });

    /* ===== Variants ===== */
    const variantInput = root.querySelector('[data-sm-variant-input]');
    const priceEl = section.querySelector('[data-sm-price]');
    const buyBtn = root.querySelector('[data-sm-buy]');
    function formatMoney(cents) {
      const c = parseInt(cents, 10) || 0;
      const major = Math.floor(c / 100);
      const minor = c % 100;
      if (minor === 0) return major + ' PLN';
      return major + ',' + (minor < 10 ? '0' + minor : minor) + ' PLN';
    }

    /* Selektory opcji: kazda opcja (np. Aplikator, Balsam) ma wlasny rzad pigulek.
       Wariant wyliczamy z kombinacji zaznaczonych wartosci. */
    const optionBtns = Array.prototype.slice.call(root.querySelectorAll('[data-sm-option-value]'));
    const variantsJsonEl = root.querySelector('[data-sm-variants-json]');
    let smVariants = [];
    if (variantsJsonEl) {
      try { smVariants = JSON.parse(variantsJsonEl.textContent); } catch (e) { smVariants = []; }
    }

    function selectedValues() {
      const out = [];
      optionBtns.forEach(function(btn) {
        if (btn.classList.contains('is-active')) {
          out[parseInt(btn.getAttribute('data-option-index'), 10)] = btn.getAttribute('data-value');
        }
      });
      return out;
    }

    function findVariant(values) {
      return smVariants.find(function(v) {
        return values.every(function(val, i) { return v.options[i] === val; });
      });
    }

    function refreshAvailability(values) {
      optionBtns.forEach(function(btn) {
        const idx = parseInt(btn.getAttribute('data-option-index'), 10);
        const test = values.slice();
        test[idx] = btn.getAttribute('data-value');
        const match = smVariants.find(function(v) {
          return test.every(function(val, i) { return val == null || v.options[i] === val; });
        });
        const ok = !!(match && match.available);
        btn.classList.toggle('is-unavailable', !ok);
        btn.setAttribute('aria-disabled', ok ? 'false' : 'true');
      });
    }

    function applySelection() {
      const values = selectedValues();
      const variant = findVariant(values);
      refreshAvailability(values);
      document.querySelectorAll('[data-sm-swap-group]').forEach(function(el) {
        const gi = parseInt(el.getAttribute('data-sm-swap-group'), 10);
        el.classList.toggle('sm-swap-hidden', values[gi] !== el.getAttribute('data-sm-swap-value'));
      });
      if (!variant) return;
      if (variantInput) variantInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      const stickyPriceEl = section.querySelector('[data-sm-sticky-price]');
      if (stickyPriceEl) stickyPriceEl.textContent = formatMoney(variant.price);
      if (buyBtn) {
        buyBtn.disabled = !variant.available;
        buyBtn.textContent = variant.available ? buyBtn.getAttribute('data-label-default') || buyBtn.textContent : 'NIEDOSTĘPNE';
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    optionBtns.forEach(function(btn) {
      if (buyBtn && !buyBtn.getAttribute('data-label-default')) {
        buyBtn.setAttribute('data-label-default', buyBtn.textContent.trim());
      }
      btn.addEventListener('click', function() {
        const idx = btn.getAttribute('data-option-index');
        optionBtns.forEach(function(b) {
          if (b.getAttribute('data-option-index') === idx) {
            b.classList.toggle('is-active', b === btn);
            b.setAttribute('aria-checked', b === btn ? 'true' : 'false');
          }
        });
        applySelection();
      });
    });
    if (optionBtns.length) applySelection();

    /* ===== Add to cart (AJAX) - opens cart drawer ===== */
    root.addEventListener('submit', function(e) {
      e.preventDefault();
      const submitBtn = root.querySelector('[data-sm-add]');
      const variantId = variantInput ? variantInput.value : null;
      const qtyEl = root.querySelector('[data-sm-qty]');
      const qty = qtyEl ? parseInt(qtyEl.value, 10) || 1 : 1;
      if (!variantId) return;
      if (submitBtn) submitBtn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: qty }], sections: 'header' })
      })
        .then(function(res) { return res.ok ? res.json() : null; })
        .then(function(data) {
          if (submitBtn) submitBtn.disabled = false;
          if (data && data.sections && data.sections.header && window.smCart) {
            window.smCart.refresh(data.sections.header);
            window.smCart.open();
          } else {
            window.location.reload();
          }
        })
        .catch(function() {
          if (submitBtn) submitBtn.disabled = false;
        });
    });

    /* ===== Routine add buttons (mobile) - AJAX + open cart drawer ===== */
    section.querySelectorAll('[data-sm-routine-form]').forEach(function(form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        const idInput = form.querySelector('input[name="id"]');
        if (!idInput || !idInput.value) return;
        const submitBtn = form.querySelector('button[type="submit"]');
        if (submitBtn) submitBtn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: idInput.value, quantity: 1 }], sections: 'header' })
        })
          .then(function(res) { return res.ok ? res.json() : null; })
          .then(function(data) {
            if (submitBtn) submitBtn.disabled = false;
            if (data && data.sections && data.sections.header && window.smCart) {
              window.smCart.refresh(data.sections.header);
              window.smCart.open();
            } else {
              window.location.reload();
            }
          })
          .catch(function() { if (submitBtn) submitBtn.disabled = false; });
      });
    });

    /* ===== Accordion - smooth grid-template-rows animation ===== */
    section.querySelectorAll('[data-sm-acc-toggle]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        const item = btn.closest('[data-sm-acc]');
        if (!item) return;
        const isOpen = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });

    /* ===== Sticky ATC bar - show when CTA section is out of view ===== */
    const stickyBar = section.querySelector('[data-sm-sticky]');
    const ctaRow = section.querySelector('.sm-pdp__cta-row');
    const stickyAddBtn = section.querySelector('[data-sm-sticky-add]');
    const stickyPriceEl = section.querySelector('[data-sm-sticky-price]');

    if (stickyBar && ctaRow && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          /* Show sticky tylko gdy cta-row scrolled PAST (powyzej viewportu),
             nie pokazuj kiedy cta-row jest jeszcze ponizej viewportu (user nie zescrollowal) */
          var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          if (scrolledPast) {
            stickyBar.setAttribute('data-visible', 'true');
            stickyBar.setAttribute('aria-hidden', 'false');
          } else {
            stickyBar.removeAttribute('data-visible');
            stickyBar.setAttribute('aria-hidden', 'true');
          }
        });
      }, { threshold: 0, rootMargin: '0px 0px -40px 0px' });
      io.observe(ctaRow);
    }

    /* Sync sticky price with main price (when variant changes) */
    if (priceEl && stickyPriceEl) {
      const priceObs = new MutationObserver(function() {
        stickyPriceEl.textContent = priceEl.textContent;
      });
      priceObs.observe(priceEl, { childList: true, characterData: true, subtree: true });
    }

    /* Sticky add button - same logic as main "Add to cart" */
    if (stickyAddBtn) {
      stickyAddBtn.addEventListener('click', function() {
        const variantId = variantInput ? variantInput.value : null;
        const qtyEl = root.querySelector('[data-sm-qty]');
        const qty = qtyEl ? parseInt(qtyEl.value, 10) || 1 : 1;
        if (!variantId) return;
        stickyAddBtn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: qty }], sections: 'header' })
        })
          .then(function(res) { return res.ok ? res.json() : null; })
          .then(function(data) {
            stickyAddBtn.disabled = false;
            if (data && data.sections && data.sections.header && window.smCart) {
              window.smCart.refresh(data.sections.header);
              window.smCart.open();
            } else {
              window.location.reload();
            }
          })
          .catch(function() { stickyAddBtn.disabled = false; });
      });
    }

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-pdp-ritual"]) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-sm-product-form]');
    if (!root) return;
    const section = root.closest('.sm-pdp');
    if (!section) return;

    /* ===== Gallery ===== */
    const mainImg = section.querySelector('[data-sm-main-image]');
    const thumbs = section.querySelectorAll('[data-sm-thumb]');
    const mainVideo = section.querySelector('[data-sm-main-video]');
    /* Preload duzych wersji w tle - pierwszy klik bez czekania na pobranie */
    function preloadThumbs() {
      thumbs.forEach(function(t) {
        const s = t.getAttribute('data-image-src');
        if (s) { const im = new Image(); im.src = s; }
      });
    }
    if (document.readyState === 'complete') preloadThumbs();
    else window.addEventListener('load', preloadThumbs, { once: true });

    const mainWrap = mainVideo ? mainVideo.closest('.sm-pdp__main') : null;
    function hideVideo() {
      if (mainWrap && mainWrap.classList.contains('is-video')) {
        mainVideo.pause();
        mainVideo.removeAttribute('src');
        mainVideo.load();
        mainWrap.classList.remove('is-video');
      }
    }

    let switchToken = 0;
    thumbs.forEach(function(th) {
      th.addEventListener('click', function() {
        const src = th.getAttribute('data-image-src');
        const alt = th.getAttribute('data-image-alt') || '';
        const vsrc = th.getAttribute('data-video-src');
        thumbs.forEach(function(t) { t.classList.remove('is-active'); });
        th.classList.add('is-active');

        /* Thumb wideo: pokaz odtwarzacz */
        if (vsrc && mainVideo && mainWrap) {
          switchToken++;
          if (src) mainVideo.poster = src;
          mainVideo.src = vsrc;
          mainWrap.classList.add('is-video');
          mainVideo.play().catch(function() {});
          return;
        }

        /* Thumb zdjecia: schowaj wideo, podmien obraz po zaladowaniu */
        hideVideo();
        if (!mainImg || !src) return;
        if (mainImg.getAttribute('src') === src) return; /* juz aktywne */
        const token = ++switchToken;
        const pre = new Image();
        pre.onload = function() {
          if (token !== switchToken) return; /* user kliknal juz inny thumb */
          mainImg.style.opacity = '0';
          setTimeout(function() {
            if (token !== switchToken) return;
            mainImg.src = src;
            mainImg.alt = alt;
            mainImg.style.opacity = '1';
          }, 150);
        };
        pre.onerror = function() {
          if (token !== switchToken) return;
          mainImg.src = src;
          mainImg.alt = alt;
          mainImg.style.opacity = '1';
        };
        pre.src = src;
      });
    });

    /* ===== Variants ===== */
    const variantInput = root.querySelector('[data-sm-variant-input]');
    const priceEl = section.querySelector('[data-sm-price]');
    const buyBtn = root.querySelector('[data-sm-buy]');
    function formatMoney(cents) {
      const c = parseInt(cents, 10) || 0;
      const major = Math.floor(c / 100);
      const minor = c % 100;
      if (minor === 0) return major + ' PLN';
      return major + ',' + (minor < 10 ? '0' + minor : minor) + ' PLN';
    }

    /* Selektory opcji: kazda opcja (np. Aplikator, Balsam) ma wlasny rzad pigulek.
       Wariant wyliczamy z kombinacji zaznaczonych wartosci. */
    const optionBtns = Array.prototype.slice.call(root.querySelectorAll('[data-sm-option-value]'));
    const variantsJsonEl = root.querySelector('[data-sm-variants-json]');
    let smVariants = [];
    if (variantsJsonEl) {
      try { smVariants = JSON.parse(variantsJsonEl.textContent); } catch (e) { smVariants = []; }
    }

    function selectedValues() {
      const out = [];
      optionBtns.forEach(function(btn) {
        if (btn.classList.contains('is-active')) {
          out[parseInt(btn.getAttribute('data-option-index'), 10)] = btn.getAttribute('data-value');
        }
      });
      return out;
    }

    function findVariant(values) {
      return smVariants.find(function(v) {
        return values.every(function(val, i) { return v.options[i] === val; });
      });
    }

    function refreshAvailability(values) {
      optionBtns.forEach(function(btn) {
        const idx = parseInt(btn.getAttribute('data-option-index'), 10);
        const test = values.slice();
        test[idx] = btn.getAttribute('data-value');
        const match = smVariants.find(function(v) {
          return test.every(function(val, i) { return val == null || v.options[i] === val; });
        });
        const ok = !!(match && match.available);
        btn.classList.toggle('is-unavailable', !ok);
        btn.setAttribute('aria-disabled', ok ? 'false' : 'true');
      });
    }

    function applySelection() {
      const values = selectedValues();
      const variant = findVariant(values);
      refreshAvailability(values);
      document.querySelectorAll('[data-sm-swap-group]').forEach(function(el) {
        const gi = parseInt(el.getAttribute('data-sm-swap-group'), 10);
        el.classList.toggle('sm-swap-hidden', values[gi] !== el.getAttribute('data-sm-swap-value'));
      });
      if (!variant) return;
      if (variantInput) variantInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      const stickyPriceEl = section.querySelector('[data-sm-sticky-price]');
      if (stickyPriceEl) stickyPriceEl.textContent = formatMoney(variant.price);
      if (buyBtn) {
        buyBtn.disabled = !variant.available;
        buyBtn.textContent = variant.available ? buyBtn.getAttribute('data-label-default') || buyBtn.textContent : 'NIEDOSTĘPNE';
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    optionBtns.forEach(function(btn) {
      if (buyBtn && !buyBtn.getAttribute('data-label-default')) {
        buyBtn.setAttribute('data-label-default', buyBtn.textContent.trim());
      }
      btn.addEventListener('click', function() {
        const idx = btn.getAttribute('data-option-index');
        optionBtns.forEach(function(b) {
          if (b.getAttribute('data-option-index') === idx) {
            b.classList.toggle('is-active', b === btn);
            b.setAttribute('aria-checked', b === btn ? 'true' : 'false');
          }
        });
        applySelection();
      });
    });
    if (optionBtns.length) applySelection();

    /* ===== Add to cart (AJAX) - opens cart drawer ===== */
    root.addEventListener('submit', function(e) {
      e.preventDefault();
      const submitBtn = root.querySelector('[data-sm-add]');
      const variantId = variantInput ? variantInput.value : null;
      const qtyEl = root.querySelector('[data-sm-qty]');
      const qty = qtyEl ? parseInt(qtyEl.value, 10) || 1 : 1;
      if (!variantId) return;
      if (submitBtn) submitBtn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: qty }], sections: 'header' })
      })
        .then(function(res) { return res.ok ? res.json() : null; })
        .then(function(data) {
          if (submitBtn) submitBtn.disabled = false;
          if (data && data.sections && data.sections.header && window.smCart) {
            window.smCart.refresh(data.sections.header);
            window.smCart.open();
          } else {
            window.location.reload();
          }
        })
        .catch(function() {
          if (submitBtn) submitBtn.disabled = false;
        });
    });

    /* ===== Routine add buttons (mobile) - AJAX + open cart drawer ===== */
    section.querySelectorAll('[data-sm-routine-form]').forEach(function(form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        const idInput = form.querySelector('input[name="id"]');
        if (!idInput || !idInput.value) return;
        const submitBtn = form.querySelector('button[type="submit"]');
        if (submitBtn) submitBtn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: idInput.value, quantity: 1 }], sections: 'header' })
        })
          .then(function(res) { return res.ok ? res.json() : null; })
          .then(function(data) {
            if (submitBtn) submitBtn.disabled = false;
            if (data && data.sections && data.sections.header && window.smCart) {
              window.smCart.refresh(data.sections.header);
              window.smCart.open();
            } else {
              window.location.reload();
            }
          })
          .catch(function() { if (submitBtn) submitBtn.disabled = false; });
      });
    });

    /* ===== Accordion - smooth grid-template-rows animation ===== */
    section.querySelectorAll('[data-sm-acc-toggle]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        const item = btn.closest('[data-sm-acc]');
        if (!item) return;
        const isOpen = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });

    /* ===== Sticky ATC bar - show when CTA section is out of view ===== */
    const stickyBar = section.querySelector('[data-sm-sticky]');
    const ctaRow = section.querySelector('.sm-pdp__cta-row');
    const stickyAddBtn = section.querySelector('[data-sm-sticky-add]');
    const stickyPriceEl = section.querySelector('[data-sm-sticky-price]');

    if (stickyBar && ctaRow && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          /* Show sticky tylko gdy cta-row scrolled PAST (powyzej viewportu),
             nie pokazuj kiedy cta-row jest jeszcze ponizej viewportu (user nie zescrollowal) */
          var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          if (scrolledPast) {
            stickyBar.setAttribute('data-visible', 'true');
            stickyBar.setAttribute('aria-hidden', 'false');
          } else {
            stickyBar.removeAttribute('data-visible');
            stickyBar.setAttribute('aria-hidden', 'true');
          }
        });
      }, { threshold: 0, rootMargin: '0px 0px -40px 0px' });
      io.observe(ctaRow);
    }

    /* Sync sticky price with main price (when variant changes) */
    if (priceEl && stickyPriceEl) {
      const priceObs = new MutationObserver(function() {
        stickyPriceEl.textContent = priceEl.textContent;
      });
      priceObs.observe(priceEl, { childList: true, characterData: true, subtree: true });
    }

    /* Sticky add button - same logic as main "Add to cart" */
    if (stickyAddBtn) {
      stickyAddBtn.addEventListener('click', function() {
        const variantId = variantInput ? variantInput.value : null;
        const qtyEl = root.querySelector('[data-sm-qty]');
        const qty = qtyEl ? parseInt(qtyEl.value, 10) || 1 : 1;
        if (!variantId) return;
        stickyAddBtn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: qty }], sections: 'header' })
        })
          .then(function(res) { return res.ok ? res.json() : null; })
          .then(function(data) {
            stickyAddBtn.disabled = false;
            if (data && data.sections && data.sections.header && window.smCart) {
              window.smCart.refresh(data.sections.header);
              window.smCart.open();
            } else {
              window.location.reload();
            }
          })
          .catch(function() { stickyAddBtn.disabled = false; });
      });
    }

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-pdp-simple"]) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-sm-product-form]');
    if (!root) return;
    const section = root.closest('.sm-pdp');
    if (!section) return;

    /* ===== Gallery ===== */
    const mainImg = section.querySelector('[data-sm-main-image]');
    const thumbs = section.querySelectorAll('[data-sm-thumb]');
    const mainVideo = section.querySelector('[data-sm-main-video]');
    /* Preload duzych wersji w tle - pierwszy klik bez czekania na pobranie */
    function preloadThumbs() {
      thumbs.forEach(function(t) {
        const s = t.getAttribute('data-image-src');
        if (s) { const im = new Image(); im.src = s; }
      });
    }
    if (document.readyState === 'complete') preloadThumbs();
    else window.addEventListener('load', preloadThumbs, { once: true });

    const mainWrap = mainVideo ? mainVideo.closest('.sm-pdp__main') : null;
    function hideVideo() {
      if (mainWrap && mainWrap.classList.contains('is-video')) {
        mainVideo.pause();
        mainVideo.removeAttribute('src');
        mainVideo.load();
        mainWrap.classList.remove('is-video');
      }
    }

    let switchToken = 0;
    thumbs.forEach(function(th) {
      th.addEventListener('click', function() {
        const src = th.getAttribute('data-image-src');
        const alt = th.getAttribute('data-image-alt') || '';
        const vsrc = th.getAttribute('data-video-src');
        thumbs.forEach(function(t) { t.classList.remove('is-active'); });
        th.classList.add('is-active');

        /* Thumb wideo: pokaz odtwarzacz */
        if (vsrc && mainVideo && mainWrap) {
          switchToken++;
          if (src) mainVideo.poster = src;
          mainVideo.src = vsrc;
          mainWrap.classList.add('is-video');
          mainVideo.play().catch(function() {});
          return;
        }

        /* Thumb zdjecia: schowaj wideo, podmien obraz po zaladowaniu */
        hideVideo();
        if (!mainImg || !src) return;
        if (mainImg.getAttribute('src') === src) return; /* juz aktywne */
        const token = ++switchToken;
        const pre = new Image();
        pre.onload = function() {
          if (token !== switchToken) return; /* user kliknal juz inny thumb */
          mainImg.style.opacity = '0';
          setTimeout(function() {
            if (token !== switchToken) return;
            mainImg.src = src;
            mainImg.alt = alt;
            mainImg.style.opacity = '1';
          }, 150);
        };
        pre.onerror = function() {
          if (token !== switchToken) return;
          mainImg.src = src;
          mainImg.alt = alt;
          mainImg.style.opacity = '1';
        };
        pre.src = src;
      });
    });

    /* ===== Variants ===== */
    const variantInput = root.querySelector('[data-sm-variant-input]');
    const variantBtns = root.querySelectorAll('[data-sm-variant]');
    const priceEl = section.querySelector('[data-sm-price]');
    const buyBtn = root.querySelector('[data-sm-buy]');
    function formatMoney(cents) {
      const c = parseInt(cents, 10) || 0;
      const major = Math.floor(c / 100);
      const minor = c % 100;
      if (minor === 0) return major + ' PLN';
      return major + ',' + (minor < 10 ? '0' + minor : minor) + ' PLN';
    }
    variantBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        if (btn.disabled) return;
        const id = btn.getAttribute('data-variant-id');
        const price = btn.getAttribute('data-variant-price');
        if (variantInput) variantInput.value = id;
        variantBtns.forEach(function(b) {
          b.classList.toggle('is-active', b === btn);
          b.setAttribute('aria-checked', b === btn ? 'true' : 'false');
        });
        if (priceEl && price) priceEl.textContent = formatMoney(price);
      });
    });

    /* ===== Add to cart (AJAX) - opens cart drawer ===== */
    root.addEventListener('submit', function(e) {
      e.preventDefault();
      const submitBtn = root.querySelector('[data-sm-add]');
      const variantId = variantInput ? variantInput.value : null;
      const qtyEl = root.querySelector('[data-sm-qty]');
      const qty = qtyEl ? parseInt(qtyEl.value, 10) || 1 : 1;
      if (!variantId) return;
      if (submitBtn) submitBtn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: qty }], sections: 'header' })
      })
        .then(function(res) { return res.ok ? res.json() : null; })
        .then(function(data) {
          if (submitBtn) submitBtn.disabled = false;
          if (data && data.sections && data.sections.header && window.smCart) {
            window.smCart.refresh(data.sections.header);
            window.smCart.open();
          } else {
            window.location.reload();
          }
        })
        .catch(function() {
          if (submitBtn) submitBtn.disabled = false;
        });
    });

    /* ===== Routine add buttons (mobile) - AJAX + open cart drawer ===== */
    section.querySelectorAll('[data-sm-routine-form]').forEach(function(form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        const idInput = form.querySelector('input[name="id"]');
        if (!idInput || !idInput.value) return;
        const submitBtn = form.querySelector('button[type="submit"]');
        if (submitBtn) submitBtn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: idInput.value, quantity: 1 }], sections: 'header' })
        })
          .then(function(res) { return res.ok ? res.json() : null; })
          .then(function(data) {
            if (submitBtn) submitBtn.disabled = false;
            if (data && data.sections && data.sections.header && window.smCart) {
              window.smCart.refresh(data.sections.header);
              window.smCart.open();
            } else {
              window.location.reload();
            }
          })
          .catch(function() { if (submitBtn) submitBtn.disabled = false; });
      });
    });

    /* ===== Accordion - smooth grid-template-rows animation ===== */
    section.querySelectorAll('[data-sm-acc-toggle]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        const item = btn.closest('[data-sm-acc]');
        if (!item) return;
        const isOpen = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });

    /* ===== Sticky ATC bar - show when CTA section is out of view ===== */
    const stickyBar = section.querySelector('[data-sm-sticky]');
    const ctaRow = section.querySelector('.sm-pdp__cta-row');
    const stickyAddBtn = section.querySelector('[data-sm-sticky-add]');
    const stickyPriceEl = section.querySelector('[data-sm-sticky-price]');

    if (stickyBar && ctaRow && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          /* Show sticky tylko gdy cta-row scrolled PAST (powyzej viewportu),
             nie pokazuj kiedy cta-row jest jeszcze ponizej viewportu (user nie zescrollowal) */
          var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          if (scrolledPast) {
            stickyBar.setAttribute('data-visible', 'true');
            stickyBar.setAttribute('aria-hidden', 'false');
          } else {
            stickyBar.removeAttribute('data-visible');
            stickyBar.setAttribute('aria-hidden', 'true');
          }
        });
      }, { threshold: 0, rootMargin: '0px 0px -40px 0px' });
      io.observe(ctaRow);
    }

    /* Sync sticky price with main price (when variant changes) */
    if (priceEl && stickyPriceEl) {
      const priceObs = new MutationObserver(function() {
        stickyPriceEl.textContent = priceEl.textContent;
      });
      priceObs.observe(priceEl, { childList: true, characterData: true, subtree: true });
    }

    /* Sticky add button - same logic as main "Add to cart" */
    if (stickyAddBtn) {
      stickyAddBtn.addEventListener('click', function() {
        const variantId = variantInput ? variantInput.value : null;
        const qtyEl = root.querySelector('[data-sm-qty]');
        const qty = qtyEl ? parseInt(qtyEl.value, 10) || 1 : 1;
        if (!variantId) return;
        stickyAddBtn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: qty }], sections: 'header' })
        })
          .then(function(res) { return res.ok ? res.json() : null; })
          .then(function(data) {
            stickyAddBtn.disabled = false;
            if (data && data.sections && data.sections.header && window.smCart) {
              window.smCart.refresh(data.sections.header);
              window.smCart.open();
            } else {
              window.location.reload();
            }
          })
          .catch(function() { stickyAddBtn.disabled = false; });
      });
    }

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-pdp"]) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-sm-product-form]');
    if (!root) return;
    const section = root.closest('.sm-pdp');
    if (!section) return;

    /* ===== Gallery ===== */
    const mainImg = section.querySelector('[data-sm-main-image]');
    const thumbs = section.querySelectorAll('[data-sm-thumb]');
    const mainVideo = section.querySelector('[data-sm-main-video]');
    /* Preload duzych wersji w tle - pierwszy klik bez czekania na pobranie */
    function preloadThumbs() {
      thumbs.forEach(function(t) {
        const s = t.getAttribute('data-image-src');
        if (s) { const im = new Image(); im.src = s; }
      });
    }
    if (document.readyState === 'complete') preloadThumbs();
    else window.addEventListener('load', preloadThumbs, { once: true });

    const mainWrap = mainVideo ? mainVideo.closest('.sm-pdp__main') : null;
    function hideVideo() {
      if (mainWrap && mainWrap.classList.contains('is-video')) {
        mainVideo.pause();
        mainVideo.removeAttribute('src');
        mainVideo.load();
        mainWrap.classList.remove('is-video');
      }
    }

    let switchToken = 0;
    thumbs.forEach(function(th) {
      th.addEventListener('click', function() {
        const src = th.getAttribute('data-image-src');
        const alt = th.getAttribute('data-image-alt') || '';
        const vsrc = th.getAttribute('data-video-src');
        thumbs.forEach(function(t) { t.classList.remove('is-active'); });
        th.classList.add('is-active');

        /* Thumb wideo: pokaz odtwarzacz */
        if (vsrc && mainVideo && mainWrap) {
          switchToken++;
          if (src) mainVideo.poster = src;
          mainVideo.src = vsrc;
          mainWrap.classList.add('is-video');
          mainVideo.play().catch(function() {});
          return;
        }

        /* Thumb zdjecia: schowaj wideo, podmien obraz po zaladowaniu */
        hideVideo();
        if (!mainImg || !src) return;
        if (mainImg.getAttribute('src') === src) return; /* juz aktywne */
        const token = ++switchToken;
        const pre = new Image();
        pre.onload = function() {
          if (token !== switchToken) return; /* user kliknal juz inny thumb */
          mainImg.style.opacity = '0';
          setTimeout(function() {
            if (token !== switchToken) return;
            mainImg.src = src;
            mainImg.alt = alt;
            mainImg.style.opacity = '1';
          }, 150);
        };
        pre.onerror = function() {
          if (token !== switchToken) return;
          mainImg.src = src;
          mainImg.alt = alt;
          mainImg.style.opacity = '1';
        };
        pre.src = src;
      });
    });

    /* ===== Variants ===== */
    const variantInput = root.querySelector('[data-sm-variant-input]');
    const variantBtns = root.querySelectorAll('[data-sm-variant]');
    const priceEl = section.querySelector('[data-sm-price]');
    const buyBtn = root.querySelector('[data-sm-buy]');
    function formatMoney(cents) {
      const c = parseInt(cents, 10) || 0;
      const major = Math.floor(c / 100);
      const minor = c % 100;
      if (minor === 0) return major + ' PLN';
      return major + ',' + (minor < 10 ? '0' + minor : minor) + ' PLN';
    }
    variantBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        if (btn.disabled) return;
        const id = btn.getAttribute('data-variant-id');
        const price = btn.getAttribute('data-variant-price');
        if (variantInput) variantInput.value = id;
        variantBtns.forEach(function(b) {
          b.classList.toggle('is-active', b === btn);
          b.setAttribute('aria-checked', b === btn ? 'true' : 'false');
        });
        if (priceEl && price) priceEl.textContent = formatMoney(price);
      });
    });

    /* ===== Add to cart (AJAX) - opens cart drawer ===== */
    root.addEventListener('submit', function(e) {
      e.preventDefault();
      const submitBtn = root.querySelector('[data-sm-add]');
      const variantId = variantInput ? variantInput.value : null;
      const qtyEl = root.querySelector('[data-sm-qty]');
      const qty = qtyEl ? parseInt(qtyEl.value, 10) || 1 : 1;
      if (!variantId) return;
      if (submitBtn) submitBtn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: qty }], sections: 'header' })
      })
        .then(function(res) { return res.ok ? res.json() : null; })
        .then(function(data) {
          if (submitBtn) submitBtn.disabled = false;
          if (data && data.sections && data.sections.header && window.smCart) {
            window.smCart.refresh(data.sections.header);
            window.smCart.open();
          } else {
            window.location.reload();
          }
        })
        .catch(function() {
          if (submitBtn) submitBtn.disabled = false;
        });
    });

    /* ===== Routine add buttons (mobile) - AJAX + open cart drawer ===== */
    section.querySelectorAll('[data-sm-routine-form]').forEach(function(form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        const idInput = form.querySelector('input[name="id"]');
        if (!idInput || !idInput.value) return;
        const submitBtn = form.querySelector('button[type="submit"]');
        if (submitBtn) submitBtn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: idInput.value, quantity: 1 }], sections: 'header' })
        })
          .then(function(res) { return res.ok ? res.json() : null; })
          .then(function(data) {
            if (submitBtn) submitBtn.disabled = false;
            if (data && data.sections && data.sections.header && window.smCart) {
              window.smCart.refresh(data.sections.header);
              window.smCart.open();
            } else {
              window.location.reload();
            }
          })
          .catch(function() { if (submitBtn) submitBtn.disabled = false; });
      });
    });

    /* ===== Accordion - smooth grid-template-rows animation ===== */
    section.querySelectorAll('[data-sm-acc-toggle]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        const item = btn.closest('[data-sm-acc]');
        if (!item) return;
        const isOpen = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });

    /* ===== Sticky ATC bar - show when CTA section is out of view ===== */
    const stickyBar = section.querySelector('[data-sm-sticky]');
    const ctaRow = section.querySelector('.sm-pdp__cta-row');
    const stickyAddBtn = section.querySelector('[data-sm-sticky-add]');
    const stickyPriceEl = section.querySelector('[data-sm-sticky-price]');

    if (stickyBar && ctaRow && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          /* Show sticky tylko gdy cta-row scrolled PAST (powyzej viewportu),
             nie pokazuj kiedy cta-row jest jeszcze ponizej viewportu (user nie zescrollowal) */
          var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          if (scrolledPast) {
            stickyBar.setAttribute('data-visible', 'true');
            stickyBar.setAttribute('aria-hidden', 'false');
          } else {
            stickyBar.removeAttribute('data-visible');
            stickyBar.setAttribute('aria-hidden', 'true');
          }
        });
      }, { threshold: 0, rootMargin: '0px 0px -40px 0px' });
      io.observe(ctaRow);
    }

    /* Sync sticky price with main price (when variant changes) */
    if (priceEl && stickyPriceEl) {
      const priceObs = new MutationObserver(function() {
        stickyPriceEl.textContent = priceEl.textContent;
      });
      priceObs.observe(priceEl, { childList: true, characterData: true, subtree: true });
    }

    /* Sticky add button - same logic as main "Add to cart" */
    if (stickyAddBtn) {
      stickyAddBtn.addEventListener('click', function() {
        const variantId = variantInput ? variantInput.value : null;
        const qtyEl = root.querySelector('[data-sm-qty]');
        const qty = qtyEl ? parseInt(qtyEl.value, 10) || 1 : 1;
        if (!variantId) return;
        stickyAddBtn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: qty }], sections: 'header' })
        })
          .then(function(res) { return res.ok ? res.json() : null; })
          .then(function(data) {
            stickyAddBtn.disabled = false;
            if (data && data.sections && data.sections.header && window.smCart) {
              window.smCart.refresh(data.sections.header);
              window.smCart.open();
            } else {
              window.location.reload();
            }
          })
          .catch(function() { stickyAddBtn.disabled = false; });
      });
    }

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-related-products"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('[data-sm-related-form]').forEach(function(form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        const idInput = form.querySelector('input[name="id"]');
        if (!idInput || !idInput.value) return;
        const submitBtn = form.querySelector('button[type="submit"]');
        if (submitBtn) submitBtn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: idInput.value, quantity: 1 }], sections: 'header' })
        })
          .then(function(res) { return res.ok ? res.json() : null; })
          .then(function(data) {
            if (submitBtn) submitBtn.disabled = false;
            if (data && data.sections && data.sections.header && window.smCart) {
              window.smCart.refresh(data.sections.header);
              window.smCart.open();
            } else {
              window.location.reload();
            }
          })
          .catch(function() { if (submitBtn) submitBtn.disabled = false; });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-rituals"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('[data-sm-carousel]').forEach(carousel => {
      if (carousel.__sm_carousel_inited) return;
      carousel.__sm_carousel_inited = true;
      const track = carousel.querySelector('[data-sm-carousel-track]');
      const prev = carousel.querySelector('[data-sm-carousel-prev]');
      const next = carousel.querySelector('[data-sm-carousel-next]');
      if (!track || !prev || !next) return;
      const scrollAmount = () => {
        const item = track.querySelector('li');
        if (!item) return 320;
        const style = window.getComputedStyle(track);
        const gap = parseFloat(style.gap) || 0;
        return item.offsetWidth + gap;
      };
      prev.addEventListener('click', () => track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' }));
      next.addEventListener('click', () => track.scrollBy({ left: scrollAmount(), behavior: 'smooth' }));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
